import React from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition';

import { AdminKeyEligibilityQuery } from '../AdminKeyEligibilityQuery';

export const PremiumAdminEvent = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const sendPremiumAdminEvent = () => {
		createAnalyticsEvent({
			type: 'sendOperationalEvent',
			data: {
				action: 'landed',
				actionSubject: 'spaPremium',
				source: 'spaPremium',
				attributes: null,
			},
		}).fire();
	};

	return (
		<AdminKeyEligibilityQuery>
			{({ edition, canBeSuperAdmin }) => {
				if (edition === ConfluenceEdition.PREMIUM && canBeSuperAdmin) {
					sendPremiumAdminEvent();
				}

				return null;
			}}
		</AdminKeyEligibilityQuery>
	);
};
